<template>
  <div class="category-wrapper">
    <!-- <layout> -->
    <Tabbar></Tabbar>
    <!-- <div  class="con"> -->
    <div class="con">
      <div class="left">
        <div
          class="conter"
          :class="index == currentIndex ? 'leftActive' : ''"
          v-for="(item, index) in CategoryList"
          :key="item.category_id"
          @click="jumpTo(item, index)"
        >
          {{ item.name }}
          <img
            v-if="index == currentIndex"
            class="FirstBg"
            src="@/assets/img/PCFirstBg.jpg"
            alt=""
          />
          <div
            v-for="(it, idx) in item.child"
            @click.stop="test(it, index, idx)"
            :class="it.category_id == childCurrentId ? 'childActive' : ''"
            class="child"
            :key="it.category_id"
          >
            {{ it.name }}
          </div>
          <!-- <div class="normal" :class="{ active: activeIndex == index }"></div> -->
        </div>
      </div>
      <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
      <div class="list-wrapper ">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :offset="500"
        >
          <div class="cateImg" ref="title">
            <!-- <img
              :src="CategoryList[CategoryActiveImg].pad_image.file_path"
              v-if="CategoryList.length > 0"
            /> -->
          </div>
          <div class="middle_content" ref="content">
            <div
              class="item"
              v-for="(items, index) in goodsList"
              :key="index"
              @click="jump(items.goods_id)"
            >
              <!-- <div class="item" v-for="(items, index) in goodsList" :key="index"> -->
              <div class="img">
                <img
                  :src="items.image[0].file_path | thumbnail(720, 720)"
                  alt
                />
              </div>
              <div class="message">
                <div class="des" style="font-size: 16px">
                  <p>{{ items.goods_name }}</p>
                  <p>产品编号：{{ items.goods_number }}</p>
                  <p>克重(g)：{{ items.sku[0].goods_weight }}</p>
                </div>
                <!-- <div v-if="!token" class="price">
                      ￥{{ items.goods_max_price }}
                    </div> -->
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div
      v-if="pagecount >= 2"
      class="page animate__animated animate__fadeInRight"
    >
      <p>{{ page }}</p>
      <p>——</p>
      <p>{{ pagecount }}</p>
    </div>
    <!-- </layout> -->
  </div>
</template>
<script>
import layout from "@/components/layout.vue";
import { getCategoryChild, getList,sendCategoryBrowseInfo } from "../../api/http.js";
import { animateCSS } from "../../utils/animate.js";
import axios from "axios";
import $ from "jquery";

import Tabbar from "@/components/Tabbar.vue";

export default {
  components: {
    layout,
    Tabbar
  },
  data() {
    return {
      user_type:'',
      token: "",
      CategoryList: [],
      CategoryActiveImg: 0,
      goodsList: [],
      ids: 0,
      activeIndex: 0,
      category_id: 0,
      itemsize: false,
      isLoading: false,
      loading: false,
      finished: false,
      currentPage: 0,
      pagecount: 0,
      pageY: 1275,
      currentIndex: 0,
      childCurrentId: null,
      categoryBrowseInfo:{
        category_id: 0, 
        click_time: 0, 
        view_duration: 0,
      }
    };
  },
  beforeDestroy(){
    this.sendCategoryBrowseInfoToServe()
  },
  created() {
    window.onscroll = () => {
      this.pageY = parseInt(window.scrollY);
    };
    this.token = localStorage.getItem("login_token");
    if (localStorage.getItem("getCategory_size") != null) {
      this.itemsize = Boolean(
        localStorage.getItem("getCategory_size") === "true"
      );
    }
    this.init(this.ids);
    // this.$nextTick(()=>{
    // this.scroll = new Bscroll(this.$refs.listWrapper, {})
    // })
  },

  activated() {
    this.categoryBrowseInfo.category_id = this.category_id;
    this.categoryBrowseInfo.click_time = Math.floor(Date.now() / 1000);
    document.body.style.background = "#eee";
    this.user_type = localStorage.getItem("user_type");
  },
  deactivated() {
    document.body.style.background = "rgba(250, 250, 250, 1)";
    this.sendCategoryBrowseInfoToServe()
  },
  computed: {
    page: function() {
      if (this.pageY <= 1275) {
        return 1;
      } else {
        if (Math.ceil(this.pageY / 2155) >= this.pagecount) {
          return this.pagecount;
        } else {
          return Math.ceil(this.pageY / 2155) + 1;
        }
      }
    }
  },
  methods: {
    sendCategoryBrowseInfoToServe(newCategorysId){
      let {category_id, click_time, view_duration} = this.categoryBrowseInfo
      view_duration = Math.floor(Date.now() / 1000) - click_time
      let token = localStorage.getItem("login_token")
      if(category_id){
          sendCategoryBrowseInfo(category_id, click_time, view_duration, token)
      }
      if(newCategorysId){
          this.categoryBrowseInfo.category_id = newCategorysId;
          this.categoryBrowseInfo.click_time = Math.floor(Date.now() / 1000);
      }
    },
    test(it, index, idx) {
      this.currentPage = 1;
      this.category_id = it.category_id;
      this.sendCategoryBrowseInfoToServe(this.category_id)
      this.childCurrentId = it.category_id;
      this.currentIndex = index;
      this.goodsList = [];
      // this.getList(1, "all", true, this.CategoryList[0].category_id, "", "");
      // this.getList(this.currentPage, "all", true, this.category_id, "", "");
      this.getList(this.currentPage, "all", true, this.category_id, "", "");
    },
    init(ids) {
      getCategoryChild().then(res => {
        this.CategoryList = res.data.list;
        //page,sortType,sortPrice,category_id,search,wxapp_id
        animateCSS(".cateImg", "fadeInDown");
        // this.getList(1, "all", true, this.CategoryList[0].category_id, "", "");
        //初始化时间统计参数
        this.categoryBrowseInfo.category_id = this.CategoryList[0].category_id
        this.categoryBrowseInfo.click_time = Math.floor(Date.now() / 1000);
        setTimeout(() => {
          let conter = document.querySelectorAll(".conter");
          let time = 200;
          conter.forEach(item => {
            setTimeout(() => {
              item.style.opacity = 1;
            }, time);
            time += 100;
          });
        }, 500);
      });
    },
    jumpTo(item, index) {
      if (item.child) {
        this.category_id = item.child[0].category_id;
        this.childCurrentId = this.category_id;
      } else {
        this.childCurrentId = null;
        this.category_id = item.category_id;
      }
      this.sendCategoryBrowseInfoToServe(this.category_id)
      this.currentIndex = index;
      this.currentPage = 0;
      this.CategoryActiveImg = index;
      this.activeIndex = index;
      this.$nextTick(() => {
        if ($(".leftActive").children().length > 1) {
          $(".leftActive")
            .children("div")
            .slideToggle(400);
        }
        this.goodsList = [];
        this.onLoad();
      });
      // animateCSS(".cateImg", "fadeOutUp");
      // animateCSS(".middle_content", "fadeInDown");
      // this.goodsList = [];
      // this.onLoad();
      // this.getList(1, "all", true, category_id, "", "", true);
    },
    jump(ids) {
      this.$router.push({
        path: "/details",
        query: {
          //路由传参时push和query搭配使用 ，作用是传递参数
          id: ids
        }
      });
    },
    onLoad() {
      this.currentPage = parseInt(this.currentPage) + 1;
      this.getList(
        this.currentPage,
        "all",
        true,
        this.category_id,
        this.searchresult || "",
        this.token
      );
    },

    getList(
      page,
      sortType,
      sortPrice,
      category_id,
      search,
      token,
      tags,
      refresh = false
    ) {
      if (refresh) {
        this.finished = false;
        this.goodsList = [];
        animateCSS(".cateImg", "fadeInDown");
      }
      getList(
        page,
        sortType,
        sortPrice,
        category_id,
        search,
        this.token,
        tags
      ).then(res => {
        console.log(res);
        this.goodsList = this.goodsList.concat(res.data.list.data);
        this.currentPage = res.data.list.current_page;
        this.pagecount = res.data.list.last_page;
        setTimeout(() => {
          document.querySelectorAll(".item").forEach(item => {
            item.style.opacity = 1;
          });
        }, 200);
        if (page == 1) {
          animateCSS(".middle_content", "fadeInUp");
        }
        if (this.user_type===null || this.user_type==='general_user' || this.currentPage >= this.pagecount) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.loading = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page {
  p {
    margin: 0;
    line-height: 1;
    font-size: 10px;
    transform: scale(0.83, 0.83);
    &:nth-of-type(1) {
      position: relative;
      top: 3px;
    }
    &:nth-of-type(2) {
      position: relative;
      top: -1px;
    }
    &:nth-of-type(3) {
      position: relative;
      top: -2px;
    }
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #ccc;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 1000;
  color: #aaa;
  font-weight: 700;
}
.left::-webkit-scrollbar {
  display: none;
}
.con {
  display: flex;
}
.middle_content {
  width: 500px;
}
#app {
  width: 1000px !important;
}

.category-wrapper {
  width: 1000px;
}

.left {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  top: 57px;
  bottom: 0;
  width: 139px;
  line-height: 40px;
  text-align: center;
  background: #fff;
  // height: 100vh;
  overflow-y: scroll;
}
.left .conter {
  position:relative;
  font-weight: 900;
  line-height: 39px;
  font-size: 14px;
  color: #1a1a1a;
  opacity: 0;
  transition: opacity 0.5s;
}
.left .child {
  font-size: 12px;
  font-weight: normal;
  height: 30px;
  line-height: 30px;
  color: #5a5a5a;
}
.left .conter .normal {
  margin: 0px auto;
  width: 30px;
  height: 4px;
  background: #fff;
}
.left .conter .active {
  margin: 0px auto;
  width: 30px;
  height: 4px;
  background: #3e210e;
}
.FirstBg{
  position:absolute;
  top:0;
  left:0;
  z-index: -1;
  width:100%;
}
.leftActive {
  color: #fff !important;
  // transition: 0.5s;
  // background: url("~@/assets/img/FirstBg.jpg") no-repeat;
  background-size: 100%;
}
.childActive {
  color: #fff !important;
  // transition: 0.5s;
  background: url("~@/assets/img/childBg.jpg") no-repeat;
  background-size: 100% 100%;
}

.van-list {
  width: 101% !important;
}
.list-wrapper {
  margin-left: 150px;
  margin-top: 58px;
  width: calc(100% - 139px);
  //   width: 100%;
}
.cateImg {
  display: none;
  width: 100%;
  height: 210px;
  overflow: hidden;
  margin-bottom: 10px;
  border-radius: 4px;
}
.cateImg img {
  width: 100%;
  position: relative;
  transform: translateY(-50%);
  top: 50%;
}
.AnimateDelay {
  animation-delay: 500ms;
}
.middle_content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  // padding-top: 15px;
}
.middle_content .item {
  transition: 0.5s;
  opacity: 0;
  width: 25%;
  height: 220px;
  box-sizing: border-box;
  margin-bottom: 10px;
  overflow: hidden;
  padding-left: 5px;
}
.middle_content .item .img {
  width: 100%;
  height: 80%;
  background: #000000;
  overflow: hidden;
}
.middle_content .item .img img {
  width: 100%;
  height: 100%;
  position: relative;
  object-fit: cover;
}
.middle_content .item .message {
  height: 20%;
  padding: 5px 0 0 5px;
  color: #3e210e;
  background: white;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow: hidden;
}
.middle_content .item .message .des {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.middle_content .item .message .des p {
  line-height: 1;
  font-size: 10px;
  transform: translateX(-13px) scale(0.83, 0.83);
  margin: 0;
  margin-bottom: 2px;
}
.right {
  position: fixed;
  right: 0;
  top: 44px;
  bottom: 0;
  width: 47px;
  line-height: 49px;
  text-align: center;
  background: #fff;
}
.right .conter {
  font-size: 13px;
}
.right .active {
  background: #3e210e;
}
</style>
